// components/layout/Navigation.jsx
import React from 'react';
import { BarChart2, BarChart3, Search, TrendingUp, Globe, Settings, ChevronLeft, ChevronRight, Building2, Database, Sparkles } from 'lucide-react';
import NavItem from './NavItem';
import NavigationSettings from './NavigationSettings';
import ProgressBar from './ProgressBar';

const Navigation = ({ isCollapsed, setIsCollapsed, activeSection, setActiveSection }) => (
    <div className={`bg-white shadow-lg transition-all flex flex-col h-full ${isCollapsed ? 'w-16' : 'w-64'}`}>
        {/* Header */}
        <div className="p-4 flex justify-between items-center border-b flex-shrink-0">
            {!isCollapsed && <h1 className="font-bold text-lg">Analytics</h1>}
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="p-1 rounded hover:bg-gray-100"
            >
                {isCollapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
            </button>
        </div>

        {/* Main Navigation */}
        <nav className="p-2 flex-shrink-0">
            <NavItem
                icon={<Sparkles />}
                label="Market Intelligence"
                isActive={activeSection === 'intelligence'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('intelligence')}
                highlight={true}
            />
            <NavItem
                icon={<BarChart3 />}
                label="Genre Analysis"
                isActive={activeSection === 'genre'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('genre')}
            />
            <NavItem
                icon={<Search />}
                label="Game Discovery"
                isActive={activeSection === 'discovery'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('discovery')}
            />
            <NavItem
                icon={<BarChart2 />}
                label="Market Analysis"
                isActive={activeSection === 'insights'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('insights')}
            />
            <NavItem
                icon={<Building2 />}
                label="Publisher Insights"
                isActive={activeSection === 'publisher'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('publisher')}
            />
            <NavItem
                icon={<TrendingUp />}
                label="Trending"
                isActive={activeSection === 'trending'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('trending')}
            />
            <NavItem
                icon={<Globe />}
                label="Regional"
                isActive={activeSection === 'regional'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('regional')}
            />
        </nav>

        {/* Divider */}
        <div className="border-t my-2 flex-shrink-0"></div>

        {/* Context-Sensitive Settings Panel */}
        {!isCollapsed && (
            <div className="flex-1 overflow-y-auto p-2">
                <NavigationSettings activeSection={activeSection} />
            </div>
        )}

        {/* Progress Bar */}
        <div className="flex-shrink-0">
            <ProgressBar />
        </div>

        {/* General Settings at Bottom */}
        <div className="p-2 border-t flex-shrink-0">
            <NavItem
                icon={<Database />}
                label="System Control"
                isActive={activeSection === 'system'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('system')}
            />
            <NavItem
                icon={<Settings />}
                label="Settings"
                isActive={activeSection === 'settings'}
                isCollapsed={isCollapsed}
                onClick={() => setActiveSection('settings')}
            />
        </div>
    </div>
);

export default Navigation;